import { surveyApi } from 'yxt-biz-pc/packages/api';

export const getSystemTime = () => {
  return surveyApi.get('/systemtimes');
};
